import type { Page, ReportColumn, ReportRecordsQuery } from '@chukua/common';
import { Table } from 'antd';
import { FileSearch, SearchX } from 'lucide-react';
import { EmptyState } from '../../../shared/components/EmptyState';
import { ListSearch } from '../../../shared/components/ListSearch';
import type { ListQueryControls } from '../../../shared/hooks/use-list-query';
import type { ReportRecord } from '../reports.api';
import { buildRecordColumns } from './build-record-columns';

interface ReportRecordsTableProps {
  columns: ReportColumn[];
  page: Page<ReportRecord>;
  list: ListQueryControls<ReportRecordsQuery>;
  isRefreshing: boolean;
}

/** The records behind the figures, server-paged under the same filters. */
export function ReportRecordsTable({ columns, page, list, isRefreshing }: ReportRecordsTableProps) {
  const emptyState = list.isFiltered ? (
    <EmptyState icon={SearchX} title="Nothing matches" description="No records match this search or these filters. Widen the period or clear a filter." />
  ) : (
    <EmptyState icon={FileSearch} title="No records yet" description="This report has no records for now." />
  );
  return (
    <div className="flex flex-col gap-4">
      <ListSearch value={list.query.q} placeholder="Search records" onSearch={(q) => list.setQuery({ q }, { replace: true })} />
      <Table
        rowKey="rowNumber"
        dataSource={page.items.map((record, index) => ({ ...record, rowNumber: index }))}
        columns={buildRecordColumns(columns, list)}
        loading={isRefreshing}
        scroll={{ x: 'max-content' }}
        locale={{ emptyText: emptyState }}
        {...list.tableProps<ReportRecord>(page.total)}
      />
    </div>
  );
}
